import React from 'react';
import { Typography } from 'antd';
import DashboardLayout from '../components/DashboardLayout';

const { Title } = Typography;

const Settings: React.FC = () => {
  return (
    <DashboardLayout>
      <div style={{ padding: '1rem' }}>
        <Title level={3}>Settings</Title>
        <p>This is the Settings page where you can manage your Settings.</p>
        {/* Add project-specific content here */}
      </div>
    </DashboardLayout>
  );
};

export default Settings;
